/**
 * Reads logged-in user from sessionStorage (set at login).
 * Used for scoping cadastro forms to the user's cliente.
 */
export function parseSessionUser() {
  try {
    const raw = sessionStorage.getItem('user');
    if (!raw) return null;
    const u = JSON.parse(raw);
    return u && typeof u === 'object' ? u : null;
  } catch {
    return null;
  }
}

/**
 * @returns {number|null} id_cliente when the user is scoped to a client, else null
 */
export function getScopedClienteIdForCreate() {
  const u = parseSessionUser();
  if (!u || u.is_superadmin === 1) return null;
  const id = u.id_cliente;
  if (id == null || id === '') return null;
  const n = Number(id);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/**
 * True when create forms should auto-fill id_cliente and disable the client control.
 */
export function shouldLockClienteOnCreate() {
  return getScopedClienteIdForCreate() != null;
}
